webpackJsonp([142629428675168],{

/***/ 410:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"allMarkdown": {
				"edges": [
					{
						"node": {
							"fields": {
								"slug": "/start-the-environment"
							},
							"excerpt": "Start components For running through the steps of the tutorial It is supposed to have a working Kubernetes cluster which serves web...",
							"timeToRead": 2,
							"frontmatter": {
								"title": "Start the environment",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/configure-the-application-schema-for-caaml"
							},
							"excerpt": "Configure the mapping Our goal is to build a mapping between the schema that has been implemented in the   database and our small portion of...",
							"timeToRead": 5,
							"frontmatter": {
								"title": "Configure the application schema for CAAML",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/clean-data"
							},
							"excerpt": "Check the integrity of data Before to move forward and use the data to populate the table that we want to design for the Region entity of...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Clean Data",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/caaml-model-design"
							},
							"excerpt": "Design of ER model for EAWS CAAML profile The model has been drafted and it's still a working progress but for the goal of the tutorial is...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "CAAML model design",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/wcs-examples"
							},
							"excerpt": "Let's see some examples of common requests for the WCS operations. We are using a demo site so please be aware that something might be...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "WCS Examples",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/wms-examples"
							},
							"excerpt": "Let's see some examples of common requests for the WMS operations. We are using a demo site so please be aware that something might be...",
							"timeToRead": 3,
							"frontmatter": {
								"title": "WMS Examples",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/wfs-examples"
							},
							"excerpt": "Let's see some examples of common requests for the WFS operations. We are using a demo site so please be aware that something might be...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "WFS Examples",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/wps-examples"
							},
							"excerpt": "Let's see some examples of common requests for the WMS operations. We are using a demo site so please be aware that something might be...",
							"timeToRead": 2,
							"frontmatter": {
								"title": "WPS Examples",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/introduction-to-ogc"
							},
							"excerpt": "The OGC Open Geospatial Consortium is an international member-based organization that develops open standards for the geospatial world...",
							"timeToRead": 3,
							"frontmatter": {
								"title": "Introduction to OGC",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/introduction-to-caaml"
							},
							"excerpt": "",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Introduction to CAAML",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/data-and-geospatial-tools"
							},
							"excerpt": "Data Courtesy of  Aineva  we are going to work with their dataset   about the Italian regions where usually the avalanche bulletin is...",
							"timeToRead": 3,
							"frontmatter": {
								"title": "Data and geospatial tools",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/introduction-to-inspire"
							},
							"excerpt": "",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Introduction to INSPIRE",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/introduction-to-wcs"
							},
							"excerpt": "What it is WCS is a standard service interface which defines and enables interoperable access to geospatial\n grid coverages . This term...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Introduction to WCS",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/introduction-to-wps"
							},
							"excerpt": "What it is Allowed operations",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Introduction to WPS",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/introduction-to-wfs"
							},
							"excerpt": "What it is WFS is a standard service interface which provides access to geographic information at the level of features and feature...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Introduction to WFS",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/introduction-to-wms"
							},
							"excerpt": "What it is WMS is a standard service interface which presents location information in an image format that can then be displayed in a map...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Introduction to WMS",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/lesson-six"
							},
							"excerpt": "Spicy jalapeno cupidatat chicken ut filet mignon sausage ut boudin nulla reprehenderit strip steak proident cillum incididunt short loin cow...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Lesson Six",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/push-the-configuration-to-geo-avalanche"
							},
							"excerpt": "Export the CAAML application schema configuration At the end of the mapping session we should have completed all the mapping properties for...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Push the configuration to GeoAvalanche",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/populate-region"
							},
							"excerpt": "Import the records to the caaml_Region table Given that the schema for a region is defined with a polygon and its center point we are going...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Populate Region",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/query-our-region-features"
							},
							"excerpt": "How to query our data Once the application schema datastore is configured we could use the  GetFeature  operation from the  WFS  service to...",
							"timeToRead": 4,
							"frontmatter": {
								"title": "Query our Region features",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/load-data"
							},
							"excerpt": "Load the shapefile into PostGIS The first thing to do is to add the dataset   to our PostGIS database  . QGIS is the quick way to go. Let's...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Load Data",
								"tags": null,
								"cover": null,
								"date": null
							}
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/post-one"
							},
							"excerpt": "Spicy jalapeno cupidatat chicken ut filet mignon sausage ut boudin nulla reprehenderit strip steak proident cillum incididunt short loin cow...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Post One",
								"tags": [
									"programming",
									"stuff",
									"other"
								],
								"cover": "https://unsplash.it/400/300/?random?BoldMage",
								"date": "01/01/2017"
							}
						}
					}
				]
			},
			"posts": {
				"edges": [
					{
						"node": {
							"fields": {
								"slug": "/post-one"
							},
							"excerpt": "Spicy jalapeno cupidatat chicken ut filet mignon sausage ut boudin nulla reprehenderit strip steak proident cillum incididunt short loin cow...",
							"timeToRead": 1,
							"frontmatter": {
								"title": "Post One",
								"tags": [
									"programming",
									"stuff",
									"other"
								],
								"cover": "https://unsplash.it/400/300/?random?BoldMage",
								"date": "01/01/2017"
							}
						}
					}
				]
			}
		},
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---index-d35e506ba2b1ac44d78c.js